export type Container = HTMLElement | ShadowRoot;

/**
 * Type d'intersection ajoutant la méthode query au container original
 */
export type EnhancedContainer<T extends Container> = T & {
  queryId<E extends HTMLElement>(id: string): E | null;
  queryClass<E extends HTMLElement>(className: string): E | null;
};

export class BnumDOM {
  /**
   * "Caste" un container pour lui injecter les extensions Bnum via un Proxy.
   * C'est l'équivalent d'une méthode d'extension C# résolue à l'exécution.
   */
  static from<T extends Container>(container: T): EnhancedContainer<T> {
    return new Proxy(container, {
      get(target, prop, receiver) {
        if (prop === 'queryId') {
          return (id: string) => {
            return target instanceof ShadowRoot
              ? target.getElementById(id)
              : target.querySelector(`#${id}`);
          };
        } else if (prop === 'queryClass') {
          return (className: string) => {
            return target instanceof ShadowRoot
              ? target.querySelector(`.${className}`)
              : target.getElementsByClassName(className)[0] || null;
          };
        }

        const value = Reflect.get(target, prop, target);
        return typeof value === 'function' ? value.bind(target) : value;
      },
    }) as EnhancedContainer<T>;
  }
}
